// Generic dialog (modal) component — not Bootstrap's .modal, kept out of this module on
// purpose (see templates/parts/dialog.twig). Ported from twifi-theme-html's
// scripts/helpers/dialog.js: hidden-attribute panel, [data-dialog-open]/[data-dialog-dismiss]
// triggers, focus-trap + Escape-key handling, body scroll lock.
//
// One addition beyond the reference: openDialog()/closeDialog() dispatch a
// 'dialog:open'/'dialog:close' CustomEvent (detail: { trigger }) on the dialog element. The
// reference's own two dialogs are static placeholders that never needed to react to being
// opened/closed or to know which trigger fired; this theme's dialogs do (resetting the
// add-payment-method Stripe form on open, and carrying which payment method's delete button
// was clicked into the confirm step) — see static/src/js/account.js.
const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

const lastFocused = new WeakMap();

function getFocusableElements(dialog) {
    return Array.from(dialog.querySelectorAll(FOCUSABLE_SELECTOR));
}

export function openDialog(dialog, trigger) {
    lastFocused.set(dialog, document.activeElement);
    dialog.hidden = false;
    document.body.classList.add('has-open-dialog');

    const closeButton = dialog.querySelector('.dialog__close');
    if (closeButton) closeButton.focus();

    dialog.dispatchEvent(new CustomEvent('dialog:open', { detail: { trigger: trigger || null } }));
}

export function closeDialog(dialog, trigger) {
    dialog.hidden = true;

    if (!document.querySelector('.dialog:not([hidden])')) document.body.classList.remove('has-open-dialog');

    const lastFocusedTrigger = lastFocused.get(dialog);
    if (lastFocusedTrigger) lastFocusedTrigger.focus();

    dialog.dispatchEvent(new CustomEvent('dialog:close', { detail: { trigger: trigger || null } }));
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-dialog-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const dialog = document.getElementById(trigger.dataset.dialogOpen);
            if (dialog) openDialog(dialog, trigger);
        });
    });

    document.querySelectorAll('.dialog').forEach((dialog) => {
        dialog.querySelectorAll('[data-dialog-dismiss]').forEach((dismiss) => {
            dismiss.addEventListener('click', () => closeDialog(dialog, dismiss));
        });

        dialog.addEventListener('keydown', (event) => {
            if (dialog.hidden) return;

            if (event.key === 'Escape') {
                closeDialog(dialog);
                return;
            }

            if (event.key !== 'Tab') return;

            const focusable = getFocusableElements(dialog);
            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });
    });
});
